import { render, staticRenderFns } from "./QZ07.vue?vue&type=template&id=6f2c8243&scoped=true"
import script from "./QZ07.vue?vue&type=script&lang=js"
export * from "./QZ07.vue?vue&type=script&lang=js"
import style0 from "./QZ07.vue?vue&type=style&index=0&id=6f2c8243&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c8243",
  null
  
)

export default component.exports